import { useEffect, useState } from "react";
import api from "../api";

// Which practice features are switched on for the signed-in user's org
// (backend core/features.py). Cached per login token for the session, so
// many components can ask without refetching. Screens for a switched-off
// feature should not render; the backend returns 404 for them anyway.
let cache = { token: null, promise: null };

function currentToken() {
  try {
    return JSON.parse(localStorage.getItem("auth") || "{}").token || null;
  } catch {
    return null;
  }
}

export function loadFeatures() {
  const token = currentToken();
  if (!token) return Promise.resolve({ enabled: [], supervises: false });
  if (cache.token !== token || !cache.promise) {
    cache = {
      token,
      promise: api.fetchFeatures().then((r) => ({ enabled: r.data?.enabled || [], supervises: Boolean(r.data?.supervises) })).catch(() => ({ enabled: [], supervises: false })),
    };
  }
  return cache.promise;
}

export default function useFeatures() {
  const [enabled, setEnabled] = useState(null);
  const [supervises, setSupervises] = useState(false);
  useEffect(() => {
    let alive = true;
    loadFeatures().then((d) => { if (alive) { setEnabled(new Set(d.enabled)); setSupervises(d.supervises); } });
    return () => { alive = false; };
  }, []);
  return {
    ready: enabled !== null,
    has: (key) => Boolean(enabled && enabled.has(key)),
    supervises, // has supervisees mapped to them, whatever their login role
  };
}
